export default __webpack_public_path__ + "static/media/interiorres.0848c5e6.jpeg";